<template>
  <VaLayout
    :top="{ fixed: true, order: 2 }"
    :left="{ fixed: true, absolute: breakpoints.mdDown, order: 1, overlay: breakpoints.mdDown && !isSidebarMinimized }"
    @leftOverlayClick="isSidebarMinimized = true"
  >
    <template #top>
      <!-- <AppNavbar :is-mobile="isMobile" /> -->
      <div v-if="isMobile" class="flex justify-between items-center pl-4 bg-white shadow md:hidden">
        <div class="text-lg font-bold">Fast and Secure Access</div>
        <span class="header ml-4">
          <VaIcon name="menu" class="lg:hidden cursor-pointer" @click="onShowMobileMenu = !onShowMobileMenu" />
        </span>
      </div>
    </template>

    <template #left>
      <AppSidebar :minimized="isSidebarMinimized" :animated="!isMobile" :mobile="isMobile" :tablet="isTablet" />
    </template>

    <template #content>
      <main
        id="main-content"
        class="p-4 min-h-[calc(100vh_-_3.5rem)] md:min-h-screen flex flex-col sm:max-w-screen-sm sm:ml-14 md:max-w-screen-lg md:ml-0 lg:max-w-screen-xl lg:ml-0 xl:ml-24 2xl:ml-28"
      >
        <RouterView />
        <MobileMenu
          :show-menu="onShowMobileMenu && width <= breakpoints.thresholds.md"
          @closeMenu="onShowMobileMenu = !onShowMobileMenu"
        />
        <VaModal
          v-model="onShowReminderModal"
          title="Reminder"
          size="small"
          no-outside-dismiss
          hide-default-actions
          stateful
          close-button
          class="p-6 rounded-lg shadow-lg"
        >
          <div class="mt-4 text-lg text-center">
            <span class="block mt-2">Please maintain your workers list.</span>
            <span class="block mt-2">Ensure workers are still active in your company.</span>
          </div>
          <div class="mt-6 flex justify-end">
            <VaButton
              size="small"
              class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
              @click="onShowReminderModal = false"
            >
              Close
            </VaButton>
          </div>
        </VaModal>
        <!-- <VaModal
          v-model="onShowCompleteRegistrationModal"
          title="Complete Registration"
          size="medium"
          no-outside-dismiss
          hide-default-actions
          stateful
          close-button
          class="p-6 rounded-lg shadow-lg"
        >
          <CompleteRegistrationForm @submit="registerUser" @cancel="onShowCompleteRegistrationModal = false" />
        </VaModal> -->
      </main>
    </template>
  </VaLayout>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref, computed, watch, toRef } from 'vue';
import { storeToRefs } from 'pinia';
import { onBeforeRouteUpdate, useRoute } from 'vue-router';
import { useBreakpoint } from 'vuestic-ui';

import { useGlobalStore } from '../stores/global-store';
import { useUserStore } from '@stores/user-store'; // Import your user store

import { useWindowSize } from '@vueuse/core';

import AppSidebar from '../components/sidebar/AppSidebar.vue';
import MobileMenu from '../components/MobileMenu.vue';

const GlobalStore = useGlobalStore();

const breakpoints = useBreakpoint();

const sidebarWidth = ref('16rem');
const sidebarMinimizedWidth = ref(undefined);

const isMobile = ref(false);
const isTablet = ref(false);
const onShowReminderModal = ref(false);
const onShowMobileMenu = ref(false);

const { width } = useWindowSize();

const { isSidebarMinimized } = storeToRefs(GlobalStore);
const userStore = useUserStore();
const route = useRoute();

const onResize = () => {
  isSidebarMinimized.value = breakpoints.mdDown;
  isMobile.value = breakpoints.smDown;
  isTablet.value = breakpoints.mdDown;
  sidebarMinimizedWidth.value = isMobile.value ? '0' : '4.5rem';
  sidebarWidth.value = isTablet.value ? '100%' : '16rem';
};

const showReminder = computed(() => route.meta.showReminder);
// const parentRoutePath = computed(() => route.meta.parentRoutePath);

onMounted(() => {
  window.addEventListener('resize', onResize);
  onResize();

  watch(
    toRef(userStore.justLoggedIn),
    (v) => {
      // if just logged in and it's meta showReminder
      if (v && showReminder.value) {
        onShowReminderModal.value = true;
        // userStore.justLoggedIn = false; // Reset to prevent retrigger
      }
    },
    { immediate: true },
  );
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', onResize);
});

onBeforeRouteUpdate(() => {
  if (breakpoints.mdDown) {
    // Collapse sidebar after route change for Mobile
    isSidebarMinimized.value = true;
  }
});
</script>

<style lang="scss" scoped>
// Prevent icon jump on animation
.va-sidebar {
  width: unset !important;
  min-width: unset !important;
}

// edge case for 912px breakpoint
@media (max-width: 912px) {
  #main-content {
    @apply max-w-screen-xl;
  }
}
</style>
